import React from 'react'


export const Header = () => {
    return (
        <h2 >

            <div ><u> <p style={{color: "#e7b3b3",}}>Expense Tracker </p> </u>



            </div>
            
        </h2>
    )
}


